import { render, staticRenderFns } from "./AttachmentRequestContinueDialog.vue?vue&type=template&id=8070ceba&scoped=true"
import script from "./AttachmentRequestContinueDialog.vue?vue&type=script&lang=ts"
export * from "./AttachmentRequestContinueDialog.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentRequestContinueDialog.vue?vue&type=style&index=0&id=8070ceba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8070ceba",
  null
  
)

export default component.exports